module.exports = __webpack_public_path__ + "img/055f287.png";